export var CONSTRUCTOR_ROUTES = {
    aboutBuilding: {
        id: 'constructor-about-building-page-id',
        route: 'about-building',
    },
    floorPlans: {
        id: 'constructor-floor-plans-page-id',
        route: 'floor-plans',
    },
    constructionSelect: {
        id: 'constructor-construction-choice-page-id',
        route: 'construction-choice',
    },
    designing: {
        id: 'constructor-designing-page-id',
        route: 'designing',
    },
    myConstructions: {
        id: 'my-constructions-page-id',
        route: 'my-constructions',
    },
    reportForm: {
        id: 'report-form-page-id',
        route: 'report-form',
    },
    ifcModel: {
        id: 'constructor-ifc-model',
        route: 'ifc-model',
    },
};
